import React, { useState } from "react";
import axios from "axios";

type Props = {
  className?: string;
};

const ContactForm = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const messageLimit = 3000;

  const [isFullNameError, setIsFullNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isMessageError, setIsMessageError] = useState(false);

  function isValidEmail(email: string): boolean {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  }

  function checkAllFields() {
    checkFullName(fullName);
    checkEmail(email);
    checkMessage(message);
  }

  function checkFullName(setedName: string) {
    if (setedName.replaceAll(" ", "") === "") {
      setIsFullNameError(true);
    } else {
      setIsFullNameError(false);
    }
  }

  function checkEmail(setedEmail: string) {
    if (!isValidEmail(setedEmail)) {
      setIsEmailError(true);
    } else {
      setIsEmailError(false);
    }
  }

  function checkMessage(setedMessage: string) {
    if (setedMessage.length > 0) {
      setIsMessageError(false);
      setMessage(setedMessage.substring(0, messageLimit));
    } else {
      setIsMessageError(true);
    }
  }

  function submitForm() {
    setIsLoading(true);
    checkAllFields();

    if (
      !isFullNameError &&
      !isEmailError &&
      !isMessageError &&
      fullName.replaceAll(" ", "") !== "" &&
      email !== "" &&
      message !== ""
    ) {
      axios
        .post("https://getform.io/f/0c915972-d219-4831-995d-865987fd95e5", {
          fullName: fullName,
          email: email,
          message: message,
        })
        .then((response) => {
          setIsFormSubmitted(true);
          setIsLoading(false);
          setFullName("");
          setEmail("");
          setMessage("");

          console.log(response);
        })
        .catch((error) => {
          setIsFormSubmitted(false);
          setIsLoading(false);
          alert("Something went wrong. Please try again later!");
          console.log(error);
        });
    } else {
      setIsFormSubmitted(false);
      setIsLoading(false);
    }
  }

  return (
    <form className={`w-full font-inter ${props.className}`}>
      <div className="flex flex-col mb-6">
        <div className="w-full">
          <label
            className="block tracking-wide text-black100 text-xs font-regular mb-2"
            htmlFor="fullName"
          >
            Full Name
          </label>
          <input
            placeholder="Your Name"
            className={`appearance-none block w-full  text-black100 border ${
              isFullNameError ? "border-red-500" : "border-borderLines"
            }    py-4 px-4  leading-tight focus:outline-none placeholder-black50`}
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
              if (isFullNameError) {
                checkFullName(e.target.value);
              }
            }}
            onBlur={(e) => {
              if (e.target.value != "") {
                checkFullName(e.target.value);
              }
            }}
            id="fullName"
            type="text"
          />
          <p
            className={`text-red-500 text-xs italic ${
              isFullNameError ? "block" : "hidden"
            } mt-2`}
          >
            Don't forget your name!
          </p>
        </div>
      </div>
      <div className="flex flex-col mb-6">
        <div className="w-full">
          <label
            className="block  tracking-wide text-black100 text-xs font-regular mb-2"
            htmlFor="email"
          >
            Email
          </label>
          <input
            placeholder="Your Email"
            className={`appearance-none block w-full  text-black100 border ${
              isEmailError ? "border-red-500" : "border-borderLines"
            }    py-4 px-4  leading-tight focus:outline-none placeholder-black50`}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (isEmailError) {
                checkEmail(e.target.value);
              }
            }}
            onBlur={(e) => {
              if (e.target.value != "") {
                checkEmail(e.target.value);
              }
            }}
            id="email"
            type="email"
          />
          <p
            className={`text-red-500 text-xs italic ${
              isEmailError ? "block" : "hidden"
            } mt-2`}
          >
            That doesn't look quite right - try again?
          </p>
        </div>
      </div>
      <div className="flex flex-col mb-6">
        <div className="w-full">
          <label
            className="block  tracking-wide text-black100 text-xs font-regular mb-2"
            htmlFor="message"
          >
            Message
          </label>
          <textarea
            className={`no-resize appearance-none block w-full text-black100 border ${
              isMessageError ? "border-red-500" : "border-borderLines"
            }  py-4 px-4  leading-tight focus:outline-none  h-56 resize-none placeholder-black50`}
            id="message"
            placeholder="I want to make something really cool!"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              if (isMessageError) {
                checkMessage(e.target.value);
              }
            }}
            onBlur={(e) => {
              if (e.target.value != "") {
                checkMessage(e.target.value);
              }
            }}
          ></textarea>
          <p
            className={`text-red-500 text-xs italic ${
              isMessageError ? "block" : "hidden"
            } mt-2`}
          >
            Please fill out this field.
          </p>
        </div>
      </div>
      <div className="md:flex md:items-center w-full">
        <div className="w-full">
          {isLoading ? (
            <button
              className="shadow uppercase bg-black100 focus:shadow-outline focus:outline-none text-white w-full py-4"
              type="button"
              onClick={submitForm}
              disabled
            >
              <svg
                role="status"
                className="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              Loading
            </button>
          ) : (
            <button
              className="shadow uppercase bg-black100 focus:shadow-outline focus:outline-none text-white w-full py-4"
              type="button"
              onClick={submitForm}
            >
              Submit
            </button>
          )}
        </div>
      </div>

      {isFormSubmitted ? (
        <p className={`text-green-500 text-sm font-regular italic block mt-2`}>
          Form submitted!
        </p>
      ) : null}
    </form>
  );
};

export default ContactForm;
